import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  forwardRef,
  Input,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Socio } from '@domain/models/socio.model';
import { PartnerService } from '@infrastructure/services/alpura/partner.service';
import { Observable, Subject, map } from 'rxjs';

@Component({
  selector: 'app-select-partner',
  templateUrl: './select-partner.component.html',
  styleUrls: ['./select-partner.component.scss'],
  providers: [
    [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SelectPartnerComponent),
        multi: true,
      },
    ],
    PartnerService,
  ],
})
export class SelectPartnerComponent implements OnInit {
  @Input() value: string = '';
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  public form: FormGroup = new FormGroup({
    partner: new FormControl(null, Validators.required),
  });

  listaPartner$: Observable<Socio[]> = new Observable<Socio[]>();
  
  private valueSubject: Subject<string> = new Subject<string>();

  constructor(private _share: PartnerService) {
    this.obtenerSocios();
    this.form.get('partner')?.valueChanges.subscribe((data) => {
      this.onInput(data)
    });
  }

  ngOnInit(): void {
    this.valueSubject.subscribe((value) => {
      this.value = value;
      this.form.get('partner')?.patchValue(value);
    });
  }

  writeValue(value: string): void {
    this.value = value;
    this.valueSubject.next(value);

  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onInput(value: string): void {
    this.value = value;
    this.onChange(value);
  }
  
  setDisabledState(isDisabled: boolean) {
    if(isDisabled) this.form.disable();
    else this.form.enable();
    
  }

  obtenerSocios() {
    this.listaPartner$ = (<Observable<Socio[]>>this._share.getSocios()).pipe(
      map((socios) =>
        socios
          .filter((socio) => socio.status === 1)
          .sort((a: any, b: any) => {
            return a.partnerNumber - b.partnerNumber;
          })
      )
    );
  }
  
  setControlValue(value: any) {
    console.log(value)
    this.value = value;
    this.form.get('partner')?.patchValue(value);
  }
}
